export const HeaderLabel = {
    myProfile: 'My Profile',
    changePassWord: 'Change Password',
    logOut: 'Logout'
}
export const navigationPathHeader = {
    profile: '/profile',
    changePassword: '/auth/change-password',
    signIn: '/auth/sign-in'
}

export const licenseCardLabel = {
    viewDetails: 'View Details'
}

export const licenseDetailsDialogSoftwareDetails = {
    bundleInfo: [
        'NV5 Geospatial has developed commercial off-the-shelf deep learning technology that is specifically designed to work with remotely sensed imagery to solve geospatial problems.',
        'The ENVI Deep Learning module removes the barriers to performing deep learning with geospatial data and is currently being used to solve problems in defense, disaster response, urban development, transportation, and other industries.'
    ],
    systemRequirements: [
        {
            title: 'Operating System',
            items: [
                'Windows 10 and 11 (Intel / AMD 64-bit)',
                'macOS 12, 13, and 14 (Intel 64-bit and M-series*)',
                'Linux (Intel/AMD 64-bit, kernel 4.18.0 or higher and glibc 2.28 or higher)'
            ]
        },
        {
            title: 'Memory (RAM)',
            items: ['Minimum of 8 GB']
        },
        {
            title: 'Number of processing cores',
            items: ['Minimum of 2, recommended 4 or more']
        },
        {
            title: 'Graphics Card',
            items: [
                'Minimum of 1 GB RAM and support for Open GL 2.0 or later',
                'The Rosetta 2 emulator is required to run Intel-based ENVI on M-series Macs. An X-Windows emulator is required on Windows.'
            ]
        }
    ]
}

export const licenseDetailsDialogLabel = {
    systemRequirements: 'ENVI has the following system requirements:',
    softwareBundle: 'Software Bundle Information'
}

export const licenseTableLabel = {
    exportSelect: ' Export Selected Data',
    errorLoading: 'Error loading licenses.',
    myLicenses: 'myLicenses',
    licenseRequests: 'License Requests',
    purchaseRequests: 'Purchase Requests',
    summary: 'summary'
}

export const PurchaseDetailsModalLabel = {
    tableHeaders: ['Product', 'Total Quantity', 'Total Price'],
    grandTotal: 'Grand Total:',
    purchaseDetails: 'Purchase Details'
}

export const telephoneInputLabel = {
    telephoneLabel: 'Telephone'
}

export const ForgotPasswordLabel = {
    verificationCode: ' If you have forgetten your password, then retrieve them by sending the verification code'
}

export const ForgotPasswordToastMessage = {
    verificationCode: 'Verification code has been sent to the registered email address.'
}
export const ForgotPasswordApiErrorMessage = {
    attemptsExceeded: 'Maximum number of attempts exceeded. Please try again after sometime.'
}
export const ForgotUsernameOrEmailLabel = {
    retrieveOption: 'If you have forgotten your username/email address, then retrieve them using the below option',
    selectOption: 'Select an option'
}
export const signInLabel = {
    login: 'Logging in...',
    geospatialSoftware: 'Geospatial Software Account Login',
    rememberMe: 'Remember me',
    noAccount: 'Don’t have an account?'
}

export const signInToastMessage = {
    passwordIncorrect: `Password is incorrect.`,
    userPool: 'User pool client ID does not exist.',
    userNotFound: 'User account does not exist.',
    verificationCode: 'Verification code has been sent to the registered email address.'
}

export const signUpLabel = {
    customAttributres: ['country', 'state', 'address1', 'city', 'pinCode', 'phoneNumber', 'accountName', 'subscribeToEmail', 'isStudent'],
    standardAttributres: ['given_name', 'family_name', 'email'],
    createUser: 'Create your user account to get access to software downloads.',
    accountRegistration: 'Account Registration',
    registrationProcess: 'If you have questions about the user account registration process, please contact geospatialsupport@nv5.com.',
    customerInformation: 'Customer Information',
    State: 'State/Province',
    loginInformation: 'Login Information',
    Registering: 'Registering...',
    IsAccount: 'Already have an account?'
}

export const signUpToastMessage = {
    isEmailAlreadyTaken: 'Email address has already been taken. Try password reset instead of registration.',
    verificationCode:
        'Verification code has been sent to the registered email address. Please enter the verification code to proceed with the registration process.'
}

export const verifyForgotPasswordLabel = {
    codeVerification: 'Code Verification',
    timeRemaining: 'Time Remaining:',
    recieveCode: `Didn't recieve code?`,
    resendCode: ' Resend Code'
}

export const verifyForgotPasswordToastMessage = {
    verificationCode: 'Verification code has been sent to the registered email address.',
    passWordChanged: 'Password has been changed successfully.'
}

export const verifyUserLabel = {
    codeVerification: 'Code Verification',
    receiveCode: `Didn't receive the code?`,
    timeRemaining: 'Time Remaining:',
    resendCode: 'Resend Code'
}
export const verifyToastMessage = {
    registeredSuccessfully: 'Congratulations, your account has been registered successfully.',
    verificationCode: 'Verification code has been sent to the registered email address.'
}

export const paymentCheckoutLabel = {
    processingPayment: 'Processing your payment...',
    checkout: 'Checkout',
    quote: 'Quote #:',
    order: 'Order #:',
    tableHeaders: ['Product Name', 'Quantity', 'Price'],
    shippingCharges: ' Shipping and Handling Charges',
    salesTax: 'Sales Tax',
    grandTotal: 'Grand Total',
    termsConditions: 'Please accept the terms and conditions to proceed with the payment.'
}
export const paymentCompletedLabel = {
    transactionNumber: 'Transaction Number:',
    transactionDate: 'Transaction Date:',
    amountPaid: 'Amount Paid:'
}

export const commercialLicensesLabel = {
    purchaseCommercial: 'Licenses',
    NoLicensesAvailable: 'No licenses available.'
}

export const StudentLicensesLabel = {
    studentLicenses: 'Academic Purchase',
    pricedLicenses: 'Priced',
    freeLicenses: 'Free',
    commercialLicenses: 'Purchase'
}

export const TrainingCoursesLabel = {
    trainingCourses: 'Training Courses',
    noCoursesAvailable: 'No courses available.'
}

export const dashboardLabel = {
    productDownloads: 'Product Downloads',
    myLicenses: 'My Licenses',
    commercialPurchase: 'Purchase',
    academicPurchase: 'Academic Purchase',
    trainingCourses: 'Training Courses',
    evaluations: 'Evaluations',
    aboutSoftware: `The software you are about to download is subject to export control laws and regulations. By downloading this
                        software, you agree that you will not knowingly, without prior written authorization from the competent government
                        authorities, export or reexport - directly or indirectly - any software downloaded from this website to any
                        prohibited destination, end-user, or end-use.`,
    latestVersion: `The latest version of the NV5 product is available in the current releases section. If you want to
                        download the previous versions of the NV5 product, then please navigate to the prior releases section.`,
    currentReleases: 'Current Releases',
    priorReleases: 'Prior Releases',
    queriesMessage: `If you have any queries, please reach out to our technical support team using the below link,`,
    commercial: 'Purchase',
    academic: 'Academic Purchase'
}

export const StatusLabel = {
    reasonCode: 'Reason code',
    description: 'Description',
    errorMessage: 'Kindly share the error with geospatialsupport@nv5.com or your sales representative to learn more about the error.',
    paymentAgain: 'Please click on the below button to initiate the payment again.',
    retryPayment: 'Retry payment',
    contactMessage: 'Please contact geospatialsupport@nv5.com or your sales representative for any order or payment related queries.'
}
